import React from "react";
import Wrapper from "../../Components/Wrapper/wrapper";
import { NotificationComponent } from "../../Components/NotificationComponent";

export const Notifications = () => {
  return (
    <Wrapper header="Notification">
      <NotificationComponent />
    </Wrapper>
  );
};
